import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo-horizontal.png';

const _withScopeId = n => (_pushScopeId("data-v-790bee94"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "FooterForMobile"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "v1",
  ref: "v1"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-img",
  src: _imports_0,
  alt: "如猫天翼"
}, null, -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text1"
}, "如猫天翼，按照门店引流的效果方式计费，让你的门店爆款产品火遍全城。", -1));

const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = {
  class: "v2"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "帮助中心", -1));

const _hoisted_9 = /*#__PURE__*/_createTextVNode("常见问题");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("关于我们");

const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"v3\" data-v-790bee94><p class=\"title\" data-v-790bee94>业务合作</p><a href=\"tel:15829504938\" data-v-790bee94>手机号：158 2950 4938</a></div><div class=\"v4\" data-v-790bee94><p class=\"title\" data-v-790bee94>加入我们</p><a href=\"tel:15829504938\" data-v-790bee94>手机号：158 2950 4938</a></div>", 2);

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "text",
  href: "http://www.beian.miit.gov.cn/",
  target: "_blank"
}, "©2020 西安如猫添翼网络科技有限公司 版权所有"), /*#__PURE__*/_createElementVNode("a", {
  class: "text2 text",
  href: "http://www.beian.miit.gov.cn/",
  target: "_blank"
}, "陕ICP备19016410号")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _hoisted_6, 512), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_router_link, {
    to: {}
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: {}
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  })]), _hoisted_11]), _hoisted_13]);
}